module.exports = __webpack_public_path__ + "static/media/middle-step-icon.e0d0a07a.svg";